<div class="p-2 dialog-container">
  <div *ngIf="!isSubmitted; else successState">
    <div class="dialog-header">
      <span class="title" mat-dialog-title>Share your feedback</span>
      <img
        src="../../../../assets/icons/svg/x-circle.svg"
        alt="Close"
        height="32"
        width="32"
        class="canvas-chat-close-button"
        (click)="closeDialog()"
        (keydown)="closeDialog()"
      />
    </div>

    <div mat-dialog-content class="heading">
      <div *ngIf="showNegativeOptions" class="negative-feedback-options">
        <div class="checkbox-group">
          <label class="checkbox-item">
            <input
              type="checkbox"
              [disabled]="viewMode"
              [(ngModel)]="feedbackOptions.wrongInformation"
            />
            <span>Missing or Wrong Citation</span>
          </label>
          <label class="checkbox-item">
            <input
              type="checkbox"
              [disabled]="viewMode"
              [(ngModel)]="feedbackOptions.notRelevant"
            />
            <span>Not relevant</span>
          </label>
          <label class="checkbox-item">
            <input
              type="checkbox"
              [disabled]="viewMode"
              [(ngModel)]="feedbackOptions.confusing"
            />
            <span>Confusing</span>
          </label>
          <label class="checkbox-item">
            <input
              type="checkbox"
              [disabled]="viewMode"
              [(ngModel)]="feedbackOptions.complexAnswer"
            />
            <span>Complex answer</span>
          </label>
          <label class="checkbox-item">
            <input
              type="checkbox"
              [disabled]="viewMode"
              [(ngModel)]="feedbackOptions.outdatedData"
            />
            <span>Outdated or Old data</span>
          </label>
          <label class="checkbox-item">
            <input
              type="checkbox"
              [disabled]="viewMode"
              [(ngModel)]="feedbackOptions.unauthorizedContent"
            />
            <span>Unauthorized or Confidential content shown</span>
          </label>
          <label class="checkbox-item">
            <input
              type="checkbox"
              [disabled]="viewMode"
              [(ngModel)]="feedbackOptions.other"
            />
            <span>Other (please specify)</span>
          </label>
        </div>
      </div>

      <p class="d-des">
        Please share any additional comments, suggestions or feedback to help us
        improve.
      </p>
      <textarea
        class="textarea-sm text-area-des w-100 scrollbar-custom-scroll-style"
        [(ngModel)]="description"
        [disabled]="viewMode"
        placeholder="Enter feedback here..."
        rows="5"
      ></textarea>
    </div>

    <div mat-dialog-actions class="skip-confirmation">
      <div class="d-flex align-items-center justify-content-end gap-3">
        <button
          *ngIf="!viewMode"
          class="skip-confirm-btn"
          [class.disabled]="!description.length"
          (click)="submitFeedbackComment()"
        >
          <span
            *ngIf="isFeedbackSubmitted"
            class="spinner-border spinner-border-save"
          ></span>
          Submit
        </button>
      </div>
    </div>
  </div>

  <ng-template #successState>
    <div class="success-state">
      <img
        class="success-icon"
        src="../../../assets/icons/svg/yes.svg"
        alt="success"
      />
      <div class="title">
        <p class="title-feedback">Feedback submitted</p>
        <p class="success-message">Your Opinion just leveled us up</p>
      </div>
    </div>
  </ng-template>
</div>
